import React, { useState, useEffect } from "react";

const FlashCard = ({ question, answer, incrementIndex }) => {
    const [showAnswer, setShowAnswer] = useState(false);

    useEffect(() => setShowAnswer(false), [question]);

    return (
        <>
            <div
                className="flashcard-container"
                onClick={() => setShowAnswer(!showAnswer)}
            >
                {!showAnswer && question}
                {showAnswer && answer}
            </div>
            {showAnswer && ( 
                <button onClick={incrementIndex} className="flashcard-button">
                    Question suivante
                </button>
            )}
        </>
    );
};

export default FlashCard;
